import { render, staticRenderFns } from "./add-chat-window.vue?vue&type=template&id=65338912&"
import script from "./add-chat-window.vue?vue&type=script&lang=js&"
export * from "./add-chat-window.vue?vue&type=script&lang=js&"
import style0 from "./add-chat-window.vue?vue&type=style&index=0&id=65338912&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports